// Bundle Selection Logic
function selectBundle(selectedCard) {
  const cards = document.querySelectorAll('.bundle-card');
  cards.forEach(card => {
    card.classList.remove('active');
    const radio = card.querySelector('input[type="radio"]');
    if(radio) radio.checked = false;
  });

  selectedCard.classList.add('active');
  const selectedRadio = selectedCard.querySelector('input[type="radio"]');
  if(selectedRadio) selectedRadio.checked = true;
}

// Accordion / FAQ Logic
function toggleAcc(headerBtn) {
  const content = headerBtn.nextElementSibling;
  const icon = headerBtn.querySelector('span');
  
  if (content.classList.contains('open')) {
    content.classList.remove('open');
    if(icon) icon.innerText = '+';
  } else {
    content.classList.add('open');
    if(icon) icon.innerText = '-';
  }
}

// Image Gallery Logic (With Auto-Slide)
let currentImageIndex = 0;
let slideInterval;

function changeImage(thumb, src, auto = false) {
  document.getElementById('mainImage').style.opacity = 0;
  
  setTimeout(() => {
    document.getElementById('mainImage').src = src;
    document.getElementById('mainImage').style.opacity = 1;
  }, 200);
  
  const thumbs = document.querySelectorAll('.gallery-thumbnails img');
  thumbs.forEach(t => t.classList.remove('active'));
  if(thumb) thumb.classList.add('active');

  // If user clicks manually, reset the auto-slider timer
  if(!auto) {
    clearInterval(slideInterval);
    startAutoSlide();
  }
}

function startAutoSlide() {
  const thumbs = document.querySelectorAll('.gallery-thumbnails img');
  if(thumbs.length > 0) {
    slideInterval = setInterval(() => {
      currentImageIndex = (currentImageIndex + 1) % thumbs.length;
      const nextThumb = thumbs[currentImageIndex];
      const nextSrc = nextThumb.getAttribute('src');
      changeImage(nextThumb, nextSrc, true);
    }, 3500); // Change image every 3.5 seconds
  }
}

// Sticky Mobile CTA Logic
document.addEventListener("DOMContentLoaded", () => {
  const stickyCta = document.getElementById("mobileStickyCta");
  const checkoutArea = document.getElementById("checkout-area");

  if(stickyCta && checkoutArea) {
    window.addEventListener("scroll", () => {
      const rect = checkoutArea.getBoundingClientRect();
      const inView = (rect.top <= window.innerHeight) && ((rect.top + rect.height) >= 0);
      
      if (window.scrollY > 500 && !inView) {
        stickyCta.classList.add("visible");
      } else {
        stickyCta.classList.remove("visible");
      }
    });
  }

  // Countdown Timer Logic
  const timerEl = document.getElementById('timer');
  if(timerEl) {
    let time = parseInt(timerEl.getAttribute('data-time') || 900); 
    setInterval(() => {
      const minutes = Math.floor(time / 60);
      let seconds = time % 60;
      seconds = seconds < 10 ? '0' + seconds : seconds;
      timerEl.innerHTML = `${minutes}:${seconds}`;
      if(time > 0) time--;
    }, 1000);
  }

  // Fake Social Proof Notification
  const popup = document.getElementById('notifPopup');
  if(popup) {
    // Read names from data attribute
    const namesData = popup.getAttribute('data-names');
    const defaultNames = ["Anna (Berlin)", "Max (München)", "Julia (Hamburg)", "Lukas (Köln)", "Sarah (Stuttgart)"];
    let names = defaultNames;
    if (namesData) {
      names = namesData.split(',').map(s => s.trim()).filter(s => s.length > 0);
      if (names.length === 0) names = defaultNames;
    }
    
    const popupName = popup.querySelector('.notif-name');
    
    setInterval(() => {
      if(popupName) {
        popupName.innerText = names[Math.floor(Math.random() * names.length)];
      }
      popup.classList.add('show');
      
      setTimeout(() => {
        popup.classList.remove('show');
      }, 4000);
      
    }, 12000); // Trigger every 12 seconds
  }

  // Start Auto Slide
  startAutoSlide();

  // Shorts Slider Navigation Logic
  const shortsSlider = document.getElementById('shortsSlider');
  const btnLeft = document.getElementById('btnSlideLeft');
  const btnRight = document.getElementById('btnSlideRight');

  if(shortsSlider && btnLeft && btnRight) {
    btnLeft.addEventListener('click', () => {
      shortsSlider.scrollBy({ left: -250, behavior: 'smooth' });
    });
    btnRight.addEventListener('click', () => {
      shortsSlider.scrollBy({ left: 250, behavior: 'smooth' });
    });
  }
});
